import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {useFormik} from "formik";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {LocalizationProvider} from "@mui/x-date-pickers-pro";
import {TimePicker} from "@mui/x-date-pickers/TimePicker";
import {
    Box,
    Button,
    CircularProgress,
    FormControl,
    FormControlLabel, FormHelperText,
    Grid,
    MenuItem,
    Switch,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import {StaticDatePicker} from "@mui/x-date-pickers/StaticDatePicker";
import {selectors as accountSelectors} from "../../../../../Ducks/account";
import {actions as opportunityActions, selectors as opportunitySelectors,} from "../../../../../Ducks/opportunity";
import {selectors as userSelectors} from "../../../../../Ducks/users";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import moment from "moment";
import {withStyles} from "@mui/styles";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import List from "@ckeditor/ckeditor5-list/src/list";
import Link from "@ckeditor/ckeditor5-link/src/link";
import AutoLink from "@ckeditor/ckeditor5-link/src/autolink";
import Indent from "@ckeditor/ckeditor5-indent/src/indent";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import HorizontalLine from "@ckeditor/ckeditor5-horizontal-line/src/horizontalline";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import Placeholder from "ckeditor5-placeholder";
import Image from "@ckeditor/ckeditor5-image/src/image";
import SimpleUploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import {Cancel, Info, Refresh} from "@mui/icons-material";
import {BASE_DOMAIN_URL} from "../../../../../API/util";
import {ADD, EDIT, FOLLOW_UP, PLANNED_ACTION} from "../../../../Utils/constants";
import {createPersonFollowUp, reschedulePersonFollowUp} from "../../../../../API/contacts";
import {LoadingButton} from "@mui/lab";
import {getWeekStartEndDate} from "../../../../Utils/dateUtils";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {selectors as contactSelectors} from "../../../../../Ducks/contacts";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import {useCallback} from "react";

const editorConfiguration = {
    plugins: [
        List,
        Placeholder,
        Essentials,
        Bold,
        Italic,
        Paragraph,
        SimpleUploadAdapter,
        ImageUpload,
        Image,
        Heading,
        Link,
        AutoLink,
        Indent,
        IndentBlock,
        Font,
        Alignment,
        Underline,
        Strikethrough,
        Table,
        TableToolbar,
        HorizontalLine,
        BlockQuote,
    ],
    toolbar: [
        "heading",
        "|",
        "Placeholder",
        "|",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "outdent",
        "indent",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "link",
        "horizontalLine",
        "blockQuote",
        "uploadImage",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "alignment:left",
        "alignment:right",
        "|",
        "insertTable",
        "|",
        "undo",
        "redo",
    ],
    alignment: {
        options: ["left", "right"],
    },
    placeholderProps: {
        types: [
            "FROM_FULLNAME",
            "FROM_FIRSTNAME",
            "FROM_LASTNAME",
            "EMAIL_SUBJECT",
            "FROM_EMAIL",
            "TO_FULLNAME",
            "TO_FIRSTNAME",
            "FIRST_MEETING_DATE",
            "FIRST_MEETING_START_TIME",
            "FIRST_MEETING_END_TIME",
            "FIRST_MEETING_DATE_AND_TIME",
            "PRODUCT_NAME",
            "PRODUCT_LOCATION",
            "PRODUCT_ADDRESS",
            "PRODUCT_ZIP_CODE",
            "PRODUCT_CITY",
            "NETWORK_DIRECTOR_1_FIRSTNAME",
            "NETWORK_DIRECTOR_1_FULLNAME",
            "NETWORK_DIRECTOR_2_FIRSTNAME",
            "NETWORK_DIRECTOR_2_FULLNAME",
        ],
    },
    placeholderBrackets: {
        open: "[",
        close: "]",
    },
    table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
    },
    simpleUpload: {
        // The URL that the images are uploaded to.
        uploadUrl: `${BASE_DOMAIN_URL}/api/events/uploadimage`,
        // Enable the XMLHttpRequest.withCredentials property.
        withCredentials: false,
        // Headers sent along with the XMLHttpRequest to the upload server.
        headers: {
            Authorization: localStorage.getItem("token"),
        },
    },
};

const useStyles = (_theme) => ({
    select: {
        "& ul": {
            display: "grid",
        },
    },
});

function AddOpportunityActionModal(props) {
    const [date, setDate] = React.useState(props.startDate ? props.startDate : new Date());
    const [startTime, setStartTime] = React.useState(props.startDate ? props.startDate : new Date());
    const [template, setTemplate] = React.useState("");
    const [editor, setEditor] = React.useState(null);
    const [reschedule, setReschedule] = React.useState(false);
    const [type, setType] = React.useState(null);
    const [isFollowUpSubmitting, setIsFollowUpSubmitting] = React.useState(false);
    const [ccUsers, setCcUsers] = React.useState([]);
    const [ccRemoveUsers, setCcRemoveUsers] = React.useState([]);
    const [availableUsers, setAvailableUsers] = React.useState([]);
    const [rescheduleEventAttendees, setRescheduleEventAttendees] = React.useState([]);
    const [undoSubject, setUndoSubject] = React.useState(null);
    const [undoSummary, setUndoSummary] = React.useState(null);
    const {
        mails,
        getMails,
        isLoading,
        user,
        emailTemplate,
        opportunity,
        addCalendarEvent,
        cronofyAuthorized,
        jobEmail,
        person,
        rescheduleAction,
        mode,
        actionType,
        rescheduleFollowUp,
        calendar,
        primaryCalendarFromPerson,
        getAllEvents,
        dateRange,
        getCalendar_loading,
        handleTodoFollowUpCallback,
        activeUsers,
        events
    } = props;

    const handleSubmit = (values) => {
        const startDateTime = moment(date).set({
            minutes: moment(startTime).minute(),
            hours: moment(startTime).hour(),
        });
        const endDateTime = moment(startDateTime).set({
            minutes: startDateTime.minute() + parseInt(values.endDuration),
        });

        const ccData = ccUsers?.map(user => ({
            email: user.user_email,
            name: `${user.user_firstname} ${user.user_lastname}`
        }));

        const removeCcData = ccRemoveUsers?.map(user => ({
            email: user.user_email,
            name: `${user.user_firstname} ${user.user_lastname}`
        }));

        values = {
            ...values,
            calendar: calendar?.primary_calendar_id !== undefined ? calendar?.primary_calendar_id : primaryCalendarFromPerson?.length > 0 ? primaryCalendarFromPerson[0]?.calendar_id : "",
            subject: values.subject.trim(),
            summary: values.summary.trim(),
            due_time: startDateTime.format("YYYY-MM-DDTHH:mm:ssZ"),
            end_time: endDateTime.format("YYYY-MM-DDTHH:mm:ssZ"),
            cc_users: ccData,
            cc_remove_users: removeCcData,
        };

        /**
         * addCalendarEvent adds a new opportunity action/planned action in system,
         * If reschedule = true, it means, existing planned action and status will be marked 'rescheduled' and
         * a new opportunity action /planned action will be created with status 'pending'.
         */
        let tempDateRange = dateRange ? dateRange : getWeekStartEndDate(new Date());

        if (type === PLANNED_ACTION) {
            values.action_type = PLANNED_ACTION;
            values.reschedule_action_id = reschedule ? rescheduleAction?.opportunity_action_id : null;

            addCalendarEvent({
                id: opportunity.main.opportunity_id,
                obj: values,
                dateRange: tempDateRange
            });

            handleClose(true);
        } else if (type === FOLLOW_UP) {
            values.action_type = FOLLOW_UP;
            setIsFollowUpSubmitting(true);

            if (mode === ADD) {
                createPersonFollowUp(person.person_id, values).then((res) => {
                    props.handleClose(true);
                    getAllEvents(tempDateRange);
                    setIsFollowUpSubmitting(false);

                    if (handleTodoFollowUpCallback !== undefined) {
                        props.handleTodoFollowUpCallback(res.data.follow_up_due_time);
                    }
                }).catch((err) => {
                    props.handleClose(true);
                    setIsFollowUpSubmitting(false);
                    toast.error(err.message, {
                        position: toast.POSITION.TOP_CENTER,
                        hideProgressBar: true,
                        autoClose: 2000
                    });
                });
            } else if (mode === EDIT) {
                reschedulePersonFollowUp(person.person_id, rescheduleFollowUp.follow_up_id, values).then(() => {
                    props.handleClose(true);
                    getAllEvents(tempDateRange);
                    setIsFollowUpSubmitting(false);
                    setReschedule(false);
                }).catch((err) => {
                    props.handleClose(true);
                    setIsFollowUpSubmitting(false);
                    setReschedule(false);
                    toast.error(err.message, {
                        position: toast.POSITION.TOP_CENTER,
                        hideProgressBar: true,
                        autoClose: 2000
                    });
                });
            }
        }
    };

    const formik = useFormik({
        validate: (values) => {
            let errors = {};

            if (values.create_google_event) {
                if (!values.subject) {
                    errors.subject = 'Required';
                }

                if (!values.summary) {
                    errors.summary = 'Required';
                } else if (values.summary.length >= 4096) {
                    errors.summary = 'Summary too big.';
                }

                if (values.cc_users?.length > 4) {
                    errors.cc_users = 'Maximum 4 CC users allowed';
                }
            }

            return errors;
        },
        onSubmit: handleSubmit,
        initialValues: {
            subject: "",
            summary: "",
            calendar: calendar?.primary_calendar_id,
            endDuration: "30",
            create_google_event: false,
            cc_users: [],
        },
    });

    const {setFieldValue, resetForm} = formik;

    const handleClose = (refresh = false) => {
        props.handleClose(refresh);
        resetForm();
        setCcUsers([]);
    };

    const autoFillExternalEvent = useCallback((action, action_uuid) => {
        let event = events?.find(e => e.event_id === action_uuid);
        let attendees = [];

        event?.attendees.forEach((attendee) => {
            if (attendee.email !== jobEmail[0]?.job_email) {
                attendee = availableUsers.find(user => user.user_email === attendee.email);

                if (attendee?.user_email) {
                    attendees.push(attendee);
                }
            }
        });

        setCcUsers(attendees);
        setRescheduleEventAttendees(attendees);
        setFieldValue('create_google_event', true);
        setFieldValue('subject', action?.subject);
        setFieldValue('summary', action?.summary);
    }, [events, availableUsers, jobEmail, setFieldValue]);

    React.useEffect(() => {
        if (opportunity) {
            const {product_id} = opportunity?.main;

            if (cronofyAuthorized) {
                var payload = {
                    productId: product_id,
                    type: "calender",
                };
                getMails(payload);
            }
        }
    }, [opportunity, cronofyAuthorized, getMails]);

    React.useEffect(() => {
        if (props.open) {
            if (actionType === PLANNED_ACTION) {
                if (rescheduleAction && mode === EDIT) {
                    if (rescheduleAction?.event_synced) {
                        autoFillExternalEvent(rescheduleAction, rescheduleAction.opportunity_action_invite_uuid);
                    }

                    const {opportunity_action_id} = rescheduleAction;
                    setFieldValue("reschedule_action_id", opportunity_action_id);
                    setReschedule(true);
                }
            } else if (actionType === FOLLOW_UP) {
                if (rescheduleFollowUp && mode === EDIT) {
                    if (rescheduleFollowUp?.event_synced) {
                        autoFillExternalEvent(rescheduleFollowUp, rescheduleFollowUp.follow_up_invite_uuid);
                    }

                    const {follow_up_id} = rescheduleFollowUp;
                    setFieldValue("reschedule_action_id", follow_up_id);
                    setReschedule(true);
                }
            }
        }
    }, [rescheduleAction, rescheduleFollowUp, mode, actionType, props.open, setFieldValue, autoFillExternalEvent]);

    React.useEffect(() => {
        setType(actionType);
    }, [actionType]);

    React.useEffect(() => {
        if (emailTemplate !== null && template !== null) {
            setFieldValue("summary", emailTemplate.main.body);
        }
    }, [emailTemplate, template, setFieldValue]);

    React.useEffect(() => {
        return () => {
            editor?.setData("");
        };
    }, [editor]);

    React.useEffect(() => {
        if (!props.open) {
            setTemplate("");
            resetForm();
        }
    }, [props.open, resetForm]);

    React.useEffect(() => {
        if (activeUsers) {
            setAvailableUsers(activeUsers.filter(activeUser =>  (activeUser.alias && activeUser.is_parent === 1) || (!activeUser.alias)));
        }
    }, [activeUsers]);

    const handleRedirect = () => {
        props.handleClose();
        props.handleTabChange("person");
    };

    const getTemplate = (e) => {
        const templateId = e.target.value;
        const template = mails.main.templates.find((t) => t.template_id === templateId);

        formik.setValues({...formik.values,
            subject: template.template_subject || template.template_name,
            summary: template.template_body
        });

        setTemplate(templateId);
    };

    const getPersonName = () => {
        if (opportunity) {
            const persons = opportunity.related_objects.persons;
            if (persons) {
                const personId = Object.keys(persons)[0];
                return persons[personId].person_firstname + " " + persons[personId].person_lastname;
            }
        } else if (person) {
            return person.person_firstname + " " + person.person_lastname;
        }

        return "";
    };

    return (
        <div>
            <Dialog maxWidth={cronofyAuthorized ? "lg" : "md"} fullWidth={!isLoading} open={props.open}
                    onClose={() => handleClose()}>
                <DialogContent>
                    {isLoading ? (
                        <CircularProgress/>
                    ) : (
                        <form onSubmit={formik.handleSubmit}>
                            {(
                                <>
                                    Plan a Meeting{" "}
                                    on <b>{moment(date).format("MMMM D, YYYY, HH:mm")}</b> with <b>{getPersonName()}</b>
                                    <Box
                                        sx={{
                                            "& .MuiTextField-root": {m: 1, width: "100%"},
                                        }}
                                    >
                                        <Grid container spacing={2}>
                                            {
                                                !(actionType === FOLLOW_UP && mode === ADD) && (rescheduleAction || rescheduleFollowUp) &&
                                                <Grid item xs={12}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                id='reschedule'
                                                                value={reschedule}
                                                                checked={reschedule}
                                                                disabled={mode === EDIT && actionType === FOLLOW_UP}
                                                                onChange={(e) => {
                                                                    const {checked} = e.target;
                                                                    setReschedule(checked);

                                                                    if (checked) {
                                                                        formik.setFieldValue('reschedule_action_id', rescheduleAction?.opportunity_action_id);

                                                                        if (rescheduleAction?.event_synced) {
                                                                            autoFillExternalEvent(rescheduleAction, rescheduleAction.opportunity_action_invite_uuid);
                                                                            formik.values.create_google_event = true;
                                                                        }
                                                                    } else {
                                                                        formik.setFieldValue('reschedule_action_id', null);
                                                                        formik.resetForm();
                                                                        setCcUsers([]);
                                                                    }
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <Box>
                                                                Reschedule
                                                                Invite {' '} (<i style={{fontSize: '12px'}}>Scheduled
                                                                                                            on: </i>
                                                                <b style={{fontSize: '12px'}}>{
                                                                    (actionType === FOLLOW_UP) ? moment(rescheduleFollowUp?.follow_up_due_time).format("MMMM D, YYYY, HH:mm") :
                                                                        moment(rescheduleAction?.opportunity_action_due_time).format("MMMM D, YYYY, HH:mm")}</b>) {' '}

                                                                {' '}
                                                                {
                                                                    !actionType ?
                                                                        <i style={{color: 'red', fontSize: '13px'}}>Turning
                                                                                                                    this
                                                                                                                    switch
                                                                                                                    on
                                                                                                                    will
                                                                                                                    reschedule
                                                                                                                    previously
                                                                                                                    completed/pending
                                                                                                                    planned
                                                                                                                    action</i>
                                                                        :
                                                                        <Tooltip
                                                                            title="Turning this switch on will reschedule previously completed/pending call">
                                                                            <Info fontSize="small" color="action"/>
                                                                        </Tooltip>
                                                                }
                                                            </Box>
                                                        }
                                                    />
                                                </Grid>
                                            }
                                            {cronofyAuthorized && (
                                                <Grid item xs={6}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                id='create_google_event'
                                                                name='create_google_event'
                                                                checked={formik.values.create_google_event}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={
                                                                    mode === EDIT && actionType === FOLLOW_UP && rescheduleFollowUp?.event_synced === 1
                                                                }
                                                            />
                                                        }
                                                        label='Send Invite to Customer'
                                                        error={formik.touched.create_google_event && (formik.errors.calendar)}
                                                    />
                                                    {formik.touched.create_google_event && formik.errors.calendar && (
                                                        <FormHelperText error>
                                                            {formik.errors.calendar}
                                                        </FormHelperText>
                                                    )}
                                                    {
                                                        (jobEmail == null || jobEmail[0]?.job_email == null || jobEmail[0]?.job_email === "") &&
                                                        formik.values.create_google_event ? (
                                                            <>
                                                                <Typography style={{color: "red"}}>
                                                                    *Person's email is missing. Please update email
                                                                    address of the person!
                                                                </Typography>
                                                                {props.handleTabChange && (
                                                                    <Typography
                                                                        onClick={() => handleRedirect()}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            textDecoration: "underline",
                                                                            color: "blue"
                                                                        }}
                                                                    >
                                                                        Click here to update.
                                                                    </Typography>
                                                                )}
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                    {formik.values.create_google_event && (
                                                        <>
                                                            <TextField
                                                                id='template'
                                                                name='template'
                                                                select
                                                                label='Select Template'
                                                                value={template}
                                                                onChange={getTemplate}
                                                            >
                                                                {mails &&
                                                                    mails.main.templates
                                                                        .filter(
                                                                            (option) =>
                                                                                option.created_by !== null &&
                                                                                option.created_by === user?.user_details?.user_id
                                                                        )
                                                                        .map((option) => (
                                                                            <MenuItem key={option.template_id}
                                                                                      value={option.template_id}>
                                                                                {option.template_name}
                                                                            </MenuItem>
                                                                        ))}
                                                            </TextField>

                                                            <TextField
                                                                label='Subject'
                                                                variant='outlined'
                                                                id='subject'
                                                                name='subject'
                                                                value={formik.values.subject}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                error={formik.touched.subject && Boolean(formik.errors.subject)}
                                                                helperText={formik.touched.subject && formik.errors.subject}
                                                            />
                                                            <Autocomplete
                                                                multiple
                                                                id="cc-users"
                                                                options={availableUsers}
                                                                getOptionLabel={(option) => `${option.user_firstname} ${option.user_lastname} (${option.user_email})`}
                                                                value={ccUsers}
                                                                onChange={(_event, newValue) => {
                                                                    const removedItems = rescheduleEventAttendees?.filter(eventAttendee => {
                                                                        return !newValue.some(newItem => newItem.user_id === eventAttendee.user_id);
                                                                    });

                                                                    if (removedItems.length > 0) {
                                                                        setCcRemoveUsers(removedItems);
                                                                    } else {
                                                                        setCcRemoveUsers([]);
                                                                    }

                                                                    setCcUsers(newValue);

                                                                    // Update Formik's field value
                                                                    formik.setFieldValue('cc_users', newValue);
                                                                    formik.setFieldTouched('cc_users', true, false);
                                                                    // Validate the field
                                                                    formik.validateField('cc_users');
                                                                }}
                                                                filterSelectedOptions
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="CC (Max 4 users)"
                                                                        placeholder="Add internal users"
                                                                        error={formik.touched.cc_users && Boolean(formik.errors.cc_users)}
                                                                        helperText={formik.touched.cc_users && formik.errors.cc_users}
                                                                    />
                                                                )}
                                                                renderTags={(value, getTagProps) =>
                                                                    value.map((option, index) => (
                                                                        <Chip
                                                                            label={`${option.user_firstname} ${option.user_lastname}`}
                                                                            {...getTagProps({ index })}
                                                                            deleteIcon={<Cancel />}
                                                                        />
                                                                    ))
                                                                }
                                                                isOptionEqualToValue={(option, value) => option.user_id === value.user_id}
                                                            />
                                                            {ccUsers?.length > 0 && (
                                                                <Typography variant="caption" color="textSecondary">
                                                                    Selected: {ccUsers.length}/4 users
                                                                </Typography>
                                                            )}
                                                            <CKEditor
                                                                id='summary'
                                                                name='summary'
                                                                editor={ClassicEditor}
                                                                config={editorConfiguration}
                                                                data={formik.values.summary}
                                                                onReady={setEditor}
                                                                onChange={(_event, editor) => {
                                                                    formik.setFieldValue("summary", editor.getData());
                                                                }}
                                                                sx={{
                                                                    border: "1px solid red"
                                                                }}
                                                            />

                                                            {formik.touched.summary && formik.errors.summary &&
                                                                <p style={{color: 'red', marginTop: '4px'}}>
                                                                    {formik.errors.summary}
                                                                </p>
                                                            }

                                                            <Button  variant='contained' color='primary'
                                                                     style={{margin: "6px"}}
                                                                     onClick={() => {
                                                                         setUndoSubject(formik.values.subject);
                                                                         setUndoSummary(formik.values.summary);

                                                                         setFieldValue('subject', '');
                                                                         setFieldValue('summary', '');
                                                                     }}>Clear Text</Button>
                                                            {
                                                                (undoSubject || undoSummary) &&
                                                                <Button  variant='contained' color='primary'
                                                                       style={{margin: "6px"}}
                                                                       onClick={() => {
                                                                           setFieldValue('subject', undoSubject);
                                                                           setFieldValue('summary', undoSummary);

                                                                           formik.setFieldTouched('subject', false);
                                                                           formik.setFieldTouched('summary', false);
                                                                       }}>
                                                                    <Refresh/><span>{" "}</span>
                                                                    Revert</Button>
                                                            }
                                                        </>
                                                    )}
                                                </Grid>
                                            )}
                                            <Grid item xs={cronofyAuthorized ? 6 : 12}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <StaticDatePicker
                                                        displayStaticWrapperAs='desktop'
                                                        value={date}
                                                        onChange={setDate}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />

                                                    <Grid container spacing={4}>
                                                        <Grid item>
                                                            <TimePicker
                                                                value={startTime}
                                                                onChange={setStartTime}
                                                                ampm={false}
                                                                renderInput={(params) => <TextField {...params} />}
                                                            />
                                                        </Grid>

                                                        <Grid item>
                                                            <FormControl>
                                                                <FormLabel
                                                                    id='demo-row-radio-buttons-group-label'>Duration</FormLabel>
                                                                <RadioGroup
                                                                    row
                                                                    aria-labelledby='demo-row-radio-buttons-group-label'
                                                                    name='endDuration'
                                                                    value={formik.values.endDuration}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                >
                                                                    <FormControlLabel value='15' control={<Radio/>}
                                                                                      label='15 minute'/>
                                                                    <FormControlLabel value='30' control={<Radio/>}
                                                                                      label='30 minute'/>
                                                                    <FormControlLabel value='45' control={<Radio/>}
                                                                                      label='45 minute'/>
                                                                    <FormControlLabel value='60' control={<Radio/>}
                                                                                      label='60 minute'/>
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </>
                            )}
                            <div style={{display: "flex", justifyContent: "center", marginTop: "12px"}}>
                                {actionType === null ? (
                                    <>
                                        <LoadingButton
                                            disabled={
                                                (jobEmail == null || jobEmail[0]?.job_email == null || jobEmail[0]?.job_email === "") &&
                                                formik.values.create_google_event
                                            }
                                            variant='contained'
                                            color='primary'
                                            type='submit'
                                            style={{marginRight: "12px"}}
                                            onClick={() => setType(PLANNED_ACTION)}
                                            loading={getCalendar_loading}
                                        >
                                            Create Planned Action
                                        </LoadingButton>

                                        <LoadingButton
                                            disabled={
                                                (jobEmail == null || jobEmail[0]?.job_email == null || jobEmail[0]?.job_email === "") &&
                                                formik.values.create_google_event
                                            }
                                            variant='contained'
                                            color='primary'
                                            type='submit'
                                            style={{marginRight: "12px"}}
                                            onClick={() => setType(FOLLOW_UP)}
                                            loading={isFollowUpSubmitting}
                                        >
                                            Create Follow Up
                                        </LoadingButton>
                                    </>
                                ) : (
                                    <LoadingButton
                                        disabled={
                                            (jobEmail == null || jobEmail[0]?.job_email == null || jobEmail[0]?.job_email === "") &&
                                            formik.values.create_google_event
                                        }
                                        variant='contained'
                                        color='primary'
                                        type='submit'
                                        style={{marginRight: "12px"}}
                                        loading={getCalendar_loading || isFollowUpSubmitting}
                                    >
                                        {actionType === PLANNED_ACTION ? "Create Planned Action" : actionType === FOLLOW_UP ? "Create Follow Up" : "Confirm"}
                                    </LoadingButton>
                                )}
                                <Button variant='contained' color='error' onClick={() => handleClose()}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
}

const mapStateToProps = (state) => ({
    isLoading: opportunitySelectors.applyEmailTemplate_loading(state),
    errorMessage: opportunitySelectors.errorMessage(state),
    opportunity: opportunitySelectors.opportunity(state),
    mails: opportunitySelectors.mails(state),
    emailTemplate: opportunitySelectors.emailTemplate(state),
    cronofyAuthorized: accountSelectors.cronofyAuthorized(state),
    calendar: opportunitySelectors.calendar(state),
    plannedAction: opportunitySelectors.plannedActionResponse(state),
    user: accountSelectors.user(state),
    rescheduleAction: opportunitySelectors.rescheduleAction(state),
    primaryCalendar: opportunitySelectors.primaryCalendar(state),
    getCalendar_loading: opportunitySelectors.getCalendar_loading(state),
    primaryCalendarFromPerson: contactSelectors.primaryCalendar(state),
    activeUsers: userSelectors.activeUsers(state),
    events: opportunitySelectors.events(state)
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            addCalendarEvent: opportunityActions.addCalendarEvent,
            getMails: opportunityActions.getMails,
            applyEmailTemplate: opportunityActions.applyEmailTemplate,
            getAllEvents: opportunityActions.getAllEvents,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(AddOpportunityActionModal));
